// src/components/Sidebar.jsx

import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import hnl from "../logos/HNLLogo_UF.png";
import tu from "../logos/Logo_TU-noBackground.png";
import "../styles/sidebar.css";

const Sidebar = () => {
  return (
    <Nav className="sidebar-clean d-none d-md-block">
      <Accordion alwaysOpen>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Overview</Accordion.Header>
          <Accordion.Body>
            <Nav.Link href="/overview#intro" className="side-link">
              Introduction
            </Nav.Link>
            <Nav.Link href="/overview#about" className="side-link">
              About this Project
            </Nav.Link>
            <Nav.Link href="/overview#contribute" className="side-link">
              How to Contribute
            </Nav.Link>
            <Nav.Link href="/overview#acknowledgments" className="side-link">
              Acknowledgements
            </Nav.Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>Tutorial</Accordion.Header>
          <Accordion.Body>
            <Nav.Link href="/tutorial#back" className="side-link">
              Background Literature
            </Nav.Link>
            <Nav.Link href="/tutorial#diff" className="side-link">
              Differentiating Components
            </Nav.Link>
            <Nav.Link href="/tutorial#howto" className="side-link">
              How to Label
            </Nav.Link>
            <Nav.Link href="/tutorial#practice" className="side-link">
              Practice Labeling
            </Nav.Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>Labeling</Accordion.Header>
          <Accordion.Body>
            <Nav.Link href="/label" className="side-link">
              Start Labeling
            </Nav.Link>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>Contact Us</Accordion.Header>
          <Accordion.Body>
            <Nav.Link href="/contact#feedback" className="side-link">
              Feedback
            </Nav.Link>
            <Nav.Link href="/contact#contribute" className="side-link">
              Contributing Data
            </Nav.Link>
            <Nav.Link href="/contact#qa" className="side-link">
              Q&A
            </Nav.Link>
            <Nav.Link href="/contact#info" className="side-link">
              Contact Info
            </Nav.Link>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <div className="sidebar-logos">
        <Row>
          <Col className="text-end">
            <img src={hnl} alt="HNL" className="side-logo" />
          </Col>
          <Col className="text-start">
            <img src={tu} alt="TU" className="side-logo" />
          </Col>
        </Row>
      </div>
    </Nav>
  );
};

export default Sidebar;
